import React from 'react';
import { useParams, Link, Navigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { COURSES } from '../data/mockData';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useLanguage } from '../context/LanguageContext';

const { FiCheck } = FiIcons;

const CourseDetail = () => {
  const { id } = useParams();
  const { t, language } = useLanguage();
  const course = COURSES.find(c => c.id === id);
  if (!course) return <Navigate to="/courses" replace />;

  return (
    <div className="pt-32 pb-24 min-h-screen">
      <div className="container mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
          <motion.div initial={{ opacity: 0, x: -30 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.6 }}>
            <img src={course.image} alt={course.title[language]} className="w-full h-[600px] object-cover shadow-soft" />
          </motion.div>
          <motion.div initial={{ opacity: 0, x: 30 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.6 }} className="flex flex-col justify-center">
            <h1 className="font-serif text-4xl md:text-5xl mb-6">{course.title[language]}</h1>
            <p className="text-text-light text-lg mb-10 leading-relaxed">{course.description[language]}</p>
            <div className="mb-10">
              <h3 className="font-serif text-2xl mb-6">{t('courseDetail.whatYouWillLearn')}</h3>
              <ul className="space-y-4">
                {course.learnings[language].map((item, i) => (
                  <li key={i} className="flex items-start gap-3 text-text-dark text-sm">
                    <SafeIcon icon={FiCheck} className="text-accent mt-1 flex-shrink-0" /> 
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
            <Link to="/contact" className="px-8 py-4 bg-text-dark text-white text-center uppercase tracking-widest text-sm hover:bg-black transition-colors">
              {t('courseDetail.enrollNow')}
            </Link>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default CourseDetail;
